import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { useUserStore } from '@/store/modules/user';
import { onMounted, ref, Ref } from 'vue';
import { OptionsType } from '@/types';
import { useDevelopersStore } from '@/store/modules/developers';
import { LegalEntitiesType } from '@/api/developer/types';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'AnnouncementsFilterInputs',
  props: {
    "developerId": {},
    "developerIdModifiers": {},
    "residentialComplexId": {},
    "residentialComplexIdModifiers": {},
    "constructionLineId": {},
    "constructionLineIdModifiers": {},
    "categoryId": {},
    "categoryIdModifiers": {},
  },
  emits: /*#__PURE__*/_mergeModels(['updateValues'], ["update:developerId", "update:residentialComplexId", "update:constructionLineId", "update:categoryId"]),
  setup(__props, { emit: __emit }) {

const developerId = _useModel<number | undefined>(__props, 'developerId');
// eslint-disable-next-line no-undef
const residentialComplexId = _useModel<number | undefined>(__props, 'residentialComplexId');
// eslint-disable-next-line no-undef
const constructionLineId = _useModel<number | undefined>(__props, 'constructionLineId');
// eslint-disable-next-line no-undef
const categoryId = _useModel<number | undefined>(__props, 'categoryId');

const emit = __emit;

const listDevelopersOptions: Ref<OptionsType[]> = ref([]);
const listResidentialComplexOptions: Ref<OptionsType[]> = ref([]);
const listConstructionLinesOptions: Ref<OptionsType[]> = ref([]);

const oldDeveloperId: Ref<number | undefined> = ref(undefined);
const oldResidentialComplexId: Ref<number | undefined> = ref(undefined);
const oldConstructionLineId: Ref<number | undefined> = ref(undefined);
const isLoading: Ref<boolean> = ref(false);

const prepareList = (res: LegalEntitiesType | undefined) => {
  categoryId.value = res.childCategory;

  if (res) {
    return res.list?.map(el => {
      return {
        id: el.id,
        name: el.value,
      };
    });
  } else {
    return [];
  }
};

const functionWithUpdate = async (action?: (id?: number) => void, id?: number) => {
  if (action) {
    await action(id);
  }

  if (
    oldDeveloperId.value !== developerId.value ||
    oldResidentialComplexId.value !== residentialComplexId.value ||
    oldConstructionLineId.value !== constructionLineId.value
  ) {
    emit('updateValues');
    oldDeveloperId.value = developerId.value;
    oldResidentialComplexId.value = residentialComplexId.value;
    oldConstructionLineId.value = constructionLineId.value;
  }
};

const updateDevelopers = async (id?: number) => {
  isLoading.value = true;
  await useDevelopersStore()
    .getDevelopers(id)
    .then(res => {
      listDevelopersOptions.value = prepareList(res);

      if (!useUserStore().user?.is_construction_company) {
        listDevelopersOptions.value.unshift({
          id: 0,
          name: 'Нет моего СК',
        });
      }
      if (!listDevelopersOptions.value?.find(el => el.id === developerId.value)) {
        if (developerId.value !== undefined) {
          developerId.value = undefined;
        }
      }
    })
    .finally(() => {
      isLoading.value = false;
    });
};
const updateConstructionLines = async (id?: number) => {
  isLoading.value = true;
  await useDevelopersStore()
    .getConstructionLines(id)
    .then(res => {
      listConstructionLinesOptions.value = prepareList(res);
      if (
        !listConstructionLinesOptions.value.find(el => el.id === constructionLineId.value)
      ) {
        if (constructionLineId.value !== undefined) {
          constructionLineId.value = undefined;
        }
      }
    })
    .finally(() => {
      isLoading.value = false;
    });
};
const updateResidentialComplex = async (id?: number) => {
  if (id !== 0) {
    isLoading.value = true;
    await useDevelopersStore()
      .getCategoryResidentialComplexes(id)
      .then(res => {
        listResidentialComplexOptions.value = prepareList(res);
        if (!useUserStore().user?.is_construction_company) {
          listResidentialComplexOptions.value.unshift({
            id: 0,
            name: 'Нет моего ЖК',
          });
        }
        if (
          !listResidentialComplexOptions.value.find(
            el => el.id === residentialComplexId.value,
          )
        ) {
          if (residentialComplexId.value !== undefined) {
            residentialComplexId.value = undefined;
            if (constructionLineId.value !== undefined) {
              constructionLineId.value = undefined;
            }
          }
        }
      })
      .finally(() => {
        isLoading.value = false;
      });
  }
};

onMounted(async () => {
  await updateDevelopers();
  await updateResidentialComplex();

  if (useUserStore().user?.is_construction_company) {
    await updateConstructionLines();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_select_input = _resolveComponent("base-select-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_select_input, {
      modelValue: developerId.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((developerId).value = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (functionWithUpdate(updateResidentialComplex, $event)))
      ],
      disabled: isLoading.value,
      options: listDevelopersOptions.value,
      label: "Выберите СК"
    }, null, 8, ["modelValue", "disabled", "options"]),
    _createVNode(_component_base_select_input, {
      modelValue: residentialComplexId.value,
      "onUpdate:modelValue": [
        _cache[2] || (_cache[2] = ($event: any) => ((residentialComplexId).value = $event)),
        _cache[3] || (_cache[3] = ($event: any) => (functionWithUpdate(updateConstructionLines, $event)))
      ],
      disabled: isLoading.value,
      options: listResidentialComplexOptions.value,
      label: "Выберите ЖК"
    }, null, 8, ["modelValue", "disabled", "options"]),
    (_unref(useUserStore)().user?.is_construction_company)
      ? (_openBlock(), _createBlock(_component_base_select_input, {
          key: 0,
          modelValue: constructionLineId.value,
          "onUpdate:modelValue": [
            _cache[4] || (_cache[4] = ($event: any) => ((constructionLineId).value = $event)),
            _cache[5] || (_cache[5] = ($event: any) => {
      functionWithUpdate(() => {
        constructionLineId.value = $event;
      })
    })
          ],
          disabled: 
      isLoading.value || (developerId.value !== undefined && residentialComplexId.value === undefined)
    ,
          options: listConstructionLinesOptions.value,
          label: "Выберите очередь"
        }, null, 8, ["modelValue", "disabled", "options"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})